/**
 * Registra o pedido do cliente no kanban de pedidos do CS (assistant/create-customer-request).
 *
 * É fire-and-forget: quem chama NÃO espera o registro. A promise devolvida nunca rejeita e
 * nem um erro síncrono (ex.: gateway quebrado) escapa daqui -- o registro não pode atrasar
 * nem derrubar o e-mail, o dialog de sucesso ou o Events. Falha só vai para o console.
 *
 * O back valida `detalhes` sem aceitar null/vazio, então só seguem os campos com texto.
 */
export function registerCustomerRequest(gateway, { tipo, accountingId, detalhes }) {
    try {
        const input = { tipo, accountingId };
        const detalhesComTexto = onlyFilledStrings(detalhes);
        if (detalhesComTexto) input.detalhes = detalhesComTexto;

        return Promise.resolve(gateway.createCustomerRequest(input)).catch(
            (error) => logError(tipo, error)
        );
    } catch (error) {
        logError(tipo, error);
        return Promise.resolve();
    }
}

function onlyFilledStrings(detalhes) {
    const filled = {};
    Object.entries(detalhes || {}).forEach(([key, value]) => {
        if (typeof value === "string" && value.trim()) filled[key] = value.trim();
    });
    return Object.keys(filled).length ? filled : undefined;
}

function logError(tipo, error) {
    console.error(
        `Não foi possível registrar o pedido "${tipo}" no kanban do CS`,
        error
    );
}
